module.exports = __webpack_public_path__ + "static/media/Rectangle318.12514736.png";